// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.HpApiWebApiError

export enum HpApiWebApiError {
  ACCOUNT_DEACTIVATED = 'accountDeactivated',
  CODE_ATTEMPTS_EXCEEDED = 'codeAttemptsExceeded',
  CODE_EXPIRED = 'codeExpired',
  EMAIL_NOT_SUPPLIED = 'emailNotSupplied',
  FORBIDDEN = 'forbidden',
  INTERNAL_SERVER_ERROR = 'internalServerError',
  INVALID_CODE = 'invalidCode',
  INVALID_CREDENTIALS = 'invalidCredentials',
  INVALID_EMAIL = 'invalidEmail',
  INVALID_PHONE = 'invalidPhone',
  INVALID_REQUEST = 'invalidRequest',
  MISSING_PARAMETERS = 'missingParameters',
  MISSING_REQUEST_BODY = 'missingRequestBody',
  NOT_AUTHENTICATED = 'notAuthenticated',
  NOT_FOUND = 'notFound',
  PASSWORD_NOT_SET = 'passwordNotSet',
  SEND_LIMIT_EXCEEDED = 'sendLimitExceeded',
  SESSION_ALREADY_AUTHENTICATED = 'sessionAlreadyAuthenticated',
  TOO_MANY_REQUESTS = 'tooManyRequests',
  USER_ALREADY_EXISTS = 'userAlreadyExists',
  VERIFICATION_TOKEN_ALREADY_USED = 'verificationTokenAlreadyUsed',
}

export const HpApiWebApiError_values = [
  HpApiWebApiError.ACCOUNT_DEACTIVATED,
  HpApiWebApiError.CODE_ATTEMPTS_EXCEEDED,
  HpApiWebApiError.CODE_EXPIRED,
  HpApiWebApiError.EMAIL_NOT_SUPPLIED,
  HpApiWebApiError.FORBIDDEN,
  HpApiWebApiError.INTERNAL_SERVER_ERROR,
  HpApiWebApiError.INVALID_CODE,
  HpApiWebApiError.INVALID_CREDENTIALS,
  HpApiWebApiError.INVALID_EMAIL,
  HpApiWebApiError.INVALID_PHONE,
  HpApiWebApiError.INVALID_REQUEST,
  HpApiWebApiError.MISSING_PARAMETERS,
  HpApiWebApiError.MISSING_REQUEST_BODY,
  HpApiWebApiError.NOT_AUTHENTICATED,
  HpApiWebApiError.NOT_FOUND,
  HpApiWebApiError.PASSWORD_NOT_SET,
  HpApiWebApiError.SEND_LIMIT_EXCEEDED,
  HpApiWebApiError.SESSION_ALREADY_AUTHENTICATED,
  HpApiWebApiError.TOO_MANY_REQUESTS,
  HpApiWebApiError.USER_ALREADY_EXISTS,
  HpApiWebApiError.VERIFICATION_TOKEN_ALREADY_USED,
] as const;
